import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import MenuBookIcon from '@material-ui/icons/MenuBook'
import { FaFileInvoiceDollar } from 'react-icons/fa'
import Box from '@material-ui/core/Box'
import { withNamespaces } from 'react-i18next'
import i18next from 'i18next'
import RequestHome from './RequestHome'
import ListRequest from './ListRequest'
import RequestBankBalance from './RequestBankBalance'
import styles from '../../styles/request.module.css'

function TabPanelRequest(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-force-tabpanel-${index}`}
            aria-labelledby={`scrollable-force-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanelRequest.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `scrollable-force-tab-${index}`,
        'aria-controls': `scrollable-force-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
}));

function ScrollableTabsButtonForce({ t }) {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [index, setIndex] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const addClick = () => {
        setIndex(0);
    }

    const historyClick = () => {
        setIndex(1);
    }

    const bankBalanceClick = () => {
        setIndex(2);
    }

    return (
        <React.Fragment>
            <div data-id="headerRequest" className={classes.root}>
                <AppBar position="static" color="default" id="appBarTitle">
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        variant="standard"
                        indicatorColor="primary"
                        textColor="primary"
                        className={"TabPage"}
                    >
                        <Tab className={"TabPageButton"} label={i18next.t('request:tabPanel.home')} {...a11yProps(0)} onClick={addClick} />
                        <Tab className={"TabPageButton"} label={t('request:tabPanel.history')} {...a11yProps(1)} onClick={historyClick} />
                        <Tab className={"TabPageButton"} label={t('request:tabPanel.bank-balance')} {...a11yProps(2)} onClick={bankBalanceClick} />
                    </Tabs>
                </AppBar>
            </div>
            {index == 0 && <RequestHome />}
            {index == 1 && <ListRequest />}
            {index == 2 && <RequestBankBalance />}
        </React.Fragment>
    );
}

export default withNamespaces(['request'], { wait: true })(ScrollableTabsButtonForce);